app.views.securityChallenge = app.views.base.extend({
  childEvents: {
    'click [data-emailaddress]': 'onDipathchMethodSelection',
    'click [data-mobileNumber]': 'onDipathchMethodSelection',
    'click [data-submit-password-reset]': 'showSpinner',
    'click [data-resend]': 'resendValidationCode',
    'focus [data-password]': 'showPasswordValidator',
    'blur [data-password]': 'hidePasswordValidator',
    'keyup [data-password]': 'validatePassword',
    'keyup [data-input]': 'onResetFormFieldChangeEventListener',
    'click [data-cancel]': 'onCancelAction',
    'keyup [data-cancel]': 'onCancelAction'
  },
  attr: {
    spinner: 'data-form-spinner',
    recoverButton: 'data-credentials-recover',
    emailAddressOption: 'data-emailaddress',
    phoneNumberOption: 'data-mobileNumber',
    submit: 'data-submit',
    resend: 'data-resend',
    resendMessageSuccessContainer: 'data-resend-message-container',
    resendMessageFailContainer: 'data-resend-message-fail-container',
    resendMessageFailText: 'data-resend-message-fail-text',
    form: 'data-form',
    input: 'data-input',
    isMobile: 'data-isMobile',
    otpIdField: 'data-otpIdField',
    contactId: 'data-contactId',
    passwordValidator: 'data-password-validator',
    passwordLength: 'data-password-length',
    passwordNumber: 'data-password-number',
    passwordUppercase: 'data-password-uppercase',
    passwordLowercse: 'data-password-lowercase',
    passwordSpecialCharacter: 'data-password-specialchar',
    passwordResetSuccess: 'data-password-reset-success'
  },
  classes: {
    errors: 'validation-summary-errors',
    disabled: 'disabled',
    resendMessage: 'resend-message',
    checkIcon: 'fa-check-circle',
    invalidIcon: 'fa-minus-circle'
  },
  settings: {
    minimumEmailChar: 4
  },
  init: function init() {},
  /**
  * Dispatch Method Selection
  * Resets radio button when swapping between mobile and email methods
  * @public
  */
  onDipathchMethodSelection: function onDipathchMethodSelection(e) {
    var isEmail = $(e.currentTarget).is('[' + this.attr.emailAddressOption + ']');
    if (isEmail) {
      $('body').find('[' + this.attr.phoneNumberOption + ']').prop('checked', false);
    } else {
      $('body').find('[' + this.attr.emailAddressOption + ']').prop('checked', false);
    }
    this._enableSubmissionAction();
  },
  /**
  * Enable Submit Action
  * Enables the form submit action allowing for the form to be submitted.
  * @private
  */
  _enableSubmissionAction: function _enableSubmissionAction() {
    var submit = $('[' + this.attr.submit + ']');
    submit.prop('disabled', false);
    submit.removeClass('btn--' + this.classes.disabled);
  },
  /**
  * Disable Submit Action
  * Disable the form submit action preventing the form being submitted.
  * @private
  */
  _disableSubmissionAction: function _disableSubmissionAction() {
    var submit = $('[' + this.attr.submit + ']');
    submit.prop('disabled', true);
    submit.addClass('btn--' + this.classes.disabled);
  },
  /**
  * On Form SUbmission Success
  * On a sucessful response calls challenge validation model
  * @public
  */
  onSubmissionSuccess: function onSubmissionSuccess(data) {
    $('[' + this.attr.spinner + ']').hide();
    if (data.NextRequestAjax) {
      this._openChallengeValidationModal(data);
    } else {
      window.location = window.location.origin + response.redirectUrl;
    }
  },
  /**
  * Open Challenge challenge validation Modal
  * @public
  */
  openChallengeValidationModal: function openChallengeValidationModal(response) {
    if (response.nextRequestAjax) {
      app.helpers.openModal(window.location.origin + response.redirectUrl, "ajax");
    } else {
      $('#AuthenticationChallengeOptions').html(response);
    }
  },
  /**
  * Resend Challenge Validation Code
  * @public
  */
  resendValidationCode: function resendValidationCode() {
    $('.form-messages').empty();
    var contactId = $('[' + this.attr.contactId + ']').val();
    var isMobile = $('[' + this.attr.isMobile + ']').val();
    var $otpIdField = $('[' + this.attr.otpIdField + ']');
    var $resendMessageSuccessContainer = $('[' + this.attr.resendMessageSuccessContainer + ']');
    var $resendMessageFailContainer = $('[' + this.attr.resendMessageFailContainer + ']');
    var $resendMessageFailText = $('[' + this.attr.resendMessageFailText + ']');
    var $spinner = $('#ChallengeValidationSpinner');
    $spinner.show();
    $resendMessageSuccessContainer.hide();
    $resendMessageFailContainer.hide();
    $resendMessageFailText.text('');
    $.ajax({
      url: "ResendVerificationCode?isMobile=" + isMobile + "&contactId=" + contactId,
      method: "GET",
      success: function success(data, status) {
        $spinner.hide();
        $otpIdField.val(data.id);
        $resendMessageSuccessContainer.show();
      },
      error: function error(xhr) {
        $spinner.hide();
        $resendMessageFailContainer.show();
        if (xhr.status === 503) {
          $resendMessageFailText.text("You have requested codes too frequently. Please wait before trying again.");
        } else {
          $resendMessageFailText.text("An error occurred while resending the code. Please try again.");
        }
      }
    });
  },
  /**
  * Show Password Validator
  * Shows popup for password validation conditions
  * @public
  */
  showPasswordValidator: function showPasswordValidator() {
    $('[' + this.attr.passwordValidator + ']').show(500);
  },
  /**
  * Hide Password Validator
  * Hide popup for password validation conditions
  * @public
  */
  hidePasswordValidator: function hidePasswordValidator() {
    $('[' + this.attr.passwordValidator + ']').hide(500);
  },
  /**
  * Validate Password
  * Validate password to check of complexity requirements
  * @public
  */
  validatePassword: function validatePassword(e) {
    var lowerCase = new RegExp('[a-z]'),
      upperCase = new RegExp('[A-Z]'),
      numbers = new RegExp('[0-9]'),
      standardCharacters = new RegExp("^[a-zA-Z0-9]+$");
    var inputValue = $(e.currentTarget).val();
    this._updatePasswordValidatorIndicators(inputValue.match(lowerCase), this.attr.passwordLowercse);
    this._updatePasswordValidatorIndicators(inputValue.match(upperCase), this.attr.passwordUppercase);
    this._updatePasswordValidatorIndicators(inputValue.match(numbers), this.attr.passwordNumber);
    this._updatePasswordValidatorIndicators(!inputValue.match(standardCharacters), this.attr.passwordSpecialCharacter);
    this._updatePasswordValidatorIndicators(inputValue.length >= 10, this.attr.passwordLength);
    if (inputValue.match(lowerCase) && inputValue.match(upperCase) && inputValue.match(numbers) && !inputValue.test(standardCharacters) && inputValue.length >= 10) this.hidePasswordValidator();else this.showPasswordValidator();
  },
  _updatePasswordValidatorIndicators: function _updatePasswordValidatorIndicators(condition, element) {
    if (condition) {
      $('[' + element + ']').removeClass(this.classes.invalidIcon);
      $('[' + element + ']').addClass(this.classes.checkIcon);
    } else {
      $('[' + element + ']').removeClass(this.classes.checkIcon);
      $('[' + element + ']').addClass(this.classes.invalidIcon);
    }
  },
  /**
  * On Show Password Event Listener
  * Fires when the user click to show the password in visible text.
  * @public
  * @param {event} e : the event of the show action.
  */
  onShowResetPasswordEventListener: function onShowResetPasswordEventListener(e) {
    var input = $(e.currentTarget).parents('.input').find('[' + this.attr.input + ']');
    if (input.attr('type') === 'password') {
      $(e.currentTarget).html('Hide');
      input.attr('type', 'text');
    } else {
      $(e.currentTarget).html('Show');
      input.attr('type', 'password');
    }
  },
  /**
  * Update Submit Action State
  * Enables or disables the submit action based on the field state and wether the terms and conditions have been confirmed.
  * @private
  */
  _updateSubmitActionState: function _updateSubmitActionState() {
    var form = $('[' + this.attr.form + ']');
    var emptyFields = this._getEmptyFieldCount(form);
    var confirm = $('[' + this.attr.confirm + ']');
    if (emptyFields > 0) {
      this._disableSubmissionAction();
    } else {
      if (confirm.length && !confirm.is(':checked')) {
        this._disableSubmissionAction();
      } else {
        this._enableSubmissionAction();
      }
    }
  },
  /**
  * Get Empty Field Count
  * Returns the length of empty fields on the active authentication form.
  * @private
  * @param {element} form : the active authentication form.
  */
  _getEmptyFieldCount: function _getEmptyFieldCount(form) {
    var inputs = form.find('[' + this.attr.input + ']');
    var emptyFields = inputs.filter(function () {
      return this.value === ''; // Find all empty inputs within the form.
    });
    return emptyFields.length;
  },
  showSpinner: function showSpinner(e) {
    e.preventDefault();
    $('[' + this.attr.spinner + ']').show();
    $('[' + this.attr.form + ']').submit();
  },
  /**
  * Cancel Action
  * Redirects to previous page when actioned
  * @public
  */
  onCancelAction: function onCancelAction(e) {
    e.preventDefault();
    if (e.keyCode === undefined || e.keyCode === 13 || e.key === 'Enter') {
      $('[' + this.attr.spinner + ']').show();
      history.back();
    }
  }
});